// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__FJUHC","logo_img":"Logo_logo_img__a29sX","textLogo_img":"Logo_textLogo_img__NcEMb","logoTitle":"Logo_logoTitle__T38MK"};